"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandlerMiddleware = void 0;
const http_error_1 = require("../http-error");
class ErrorHandlerMiddleware {
    onError(context) {
        throw new http_error_1.HttpError(0, context.error.message, {
            cause: context.error.cause,
            stack: context.error.stack,
            fetchUrl: context.url,
            fetchInit: context.init,
        });
    }
    // Warning: The typescript-fetch code generated by openapi-generator
    // clones the response before passing it to post middleware. This causes
    // a problem when the response size is large (e.g. more than 32768).
    // Our Nursys batch AWS Lambda code would just die after receiving 32768 bytes.
    // This seems to relate to https://github.com/node-fetch/node-fetch/issues/139
    // The only known solution for now is to avoid using this post middleware to
    // format non-success responses.
    async post(context) {
        if (context.response?.ok) {
            return context.response;
        }
        throw new http_error_1.HttpError(context.response?.status || 0, (await context.response?.text()) ?? 'Unknown Error');
    }
}
exports.ErrorHandlerMiddleware = ErrorHandlerMiddleware;
//# sourceMappingURL=error-handler.js.map